import m from "mithril"
import { state, getYouTubeEmbedUrl } from "../state/store.js"
import { TemperatureGlobe } from "./TemperatureGlobe.js"

var lightbox = {
  open: false,
  images: [],
  index: 0,
}

function openLightbox(images, index) {
  lightbox.images = images
  lightbox.index = index
  lightbox.open = true
}

function closeLightbox(e) {
  if (e) e.stopPropagation()
  lightbox.open = false
}

function lightboxPrev(e) {
  e.stopPropagation()
  lightbox.index = (lightbox.index - 1 + lightbox.images.length) % lightbox.images.length
}

function lightboxNext(e) {
  e.stopPropagation()
  lightbox.index = (lightbox.index + 1) % lightbox.images.length
}

function closeModal() {
  lightbox.open = false
  m.route.set("/")
}

function onKeyDown(e) {
  if (lightbox.open) {
    if (e.key === "Escape") { closeLightbox(); m.redraw() }
    else if (e.key === "ArrowLeft") { lightboxPrev(e); m.redraw() }
    else if (e.key === "ArrowRight") { lightboxNext(e); m.redraw() }
    return
  }
  if (e.key === "Escape") closeModal()
}

function LightboxOverlay() {
  return {
    view: function () {
      if (!lightbox.open || lightbox.images.length === 0) return null

      var src = lightbox.images[lightbox.index]
      var hasMultiple = lightbox.images.length > 1

      return m("div.lightbox-overlay", { onclick: closeLightbox }, [
        m("button.lightbox-close", {
          "aria-label": "Close lightbox",
          onclick: closeLightbox,
        }, [
          m("svg", { width: 28, height: 28, viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", "stroke-width": 2 },
            m("path", { d: "M18 6L6 18M6 6l12 12" })),
        ]),

        hasMultiple ? m("button.lightbox-nav.lightbox-prev", {
          "aria-label": "Previous image",
          onclick: lightboxPrev,
        }, [
          m("svg", { width: 32, height: 32, viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", "stroke-width": 2 },
            m("path", { d: "M15 18l-6-6 6-6" })),
        ]) : null,

        m("div.lightbox-image-wrapper", {
          onclick: function (e) { e.stopPropagation() },
        }, [
          m("img.lightbox-image", { src: src, alt: "Image " + (lightbox.index + 1) }),
        ]),

        hasMultiple ? m("button.lightbox-nav.lightbox-next", {
          "aria-label": "Next image",
          onclick: lightboxNext,
        }, [
          m("svg", { width: 32, height: 32, viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", "stroke-width": 2 },
            m("path", { d: "M9 18l6-6-6-6" })),
        ]) : null,

        hasMultiple ? m("div.lightbox-counter",
          (lightbox.index + 1) + " / " + lightbox.images.length
        ) : null,
      ])
    },
  }
}

export default {
  oncreate: function () {
    document.addEventListener("keydown", onKeyDown)
  },
  onremove: function () {
    document.removeEventListener("keydown", onKeyDown)
  },
  view: function (vnode) {
    var project = vnode.attrs.project
    var isOpen = !!project

    if (isOpen) {
      document.body.style.overflow = "hidden"
    } else {
      document.body.style.overflow = ""
    }

    var label = project ? (state.categoryLabels[project.category] || project.category) : ""

    // Build the full list of clickable images for the lightbox
    var allImages = []
    if (project) {
      if (project.image) allImages.push(project.image)
      if (project.galleryImages && project.galleryImages.length) {
        project.galleryImages.forEach(function (src) {
          if (allImages.indexOf(src) === -1) allImages.push(src)
        })
      }
    }

    // Check for special interactive projects
    var isTemperatureGlobe = project && project.id === 1;
    var isInteractive = isTemperatureGlobe;

    return m("div.modal", { class: isOpen ? "open" : "" }, [
      m("div.modal-backdrop", { onclick: closeModal }),
      m("div.modal-panel", {
        // Expand width for interactive components
        style: isInteractive ? "max-width: 100%; width: 100%;" : ""
      }, [
        m("button.modal-close", {
          "aria-label": "Close project",
          onclick: closeModal,
        }, [
          m("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", "stroke-width": 2 },
            m("path", { d: "M18 6L6 18M6 6l12 12" })),
        ]),
        m("div.modal-scroll", isOpen ? [
          // Standard Hero Image (only if NOT interactive or if we want it above)
          !isInteractive ? m("div.modal-hero", {
            style: { background: project.color, cursor: "pointer" },
            onclick: function () {
              if (project.image) openLightbox(allImages, 0)
            },
          }, [
            m("img", { src: project.image, alt: project.title }),
          ]) : null,

          m("div.modal-body", {
             // Use single column for interactive components
             style: isInteractive ? "grid-template-columns: 1fr; max-width: 1400px; margin: 0 auto;" : ""
          }, [
            m("div.modal-main", [
              m("div.modal-tags", [
                m("span.card-tag", label),
                m("span.card-tag", project.year),
              ]),
              m("h1.modal-title", project.title),
              
              // Standard Description
              m("p.modal-description", project.fullDescription || project.description),

              // Project URL Button
              project.url ? m("a.modal-link-btn", {
                href: project.url,
                target: "_blank",
                rel: "noopener noreferrer",
                style: "display: inline-flex; align-items: center; gap: 8px; margin-top: 1.5rem; padding: 10px 20px; background: var(--color-text); color: white; border-radius: 100px; font-weight: 500; font-size: 0.875rem; transition: opacity 0.2s;"
              }, [
                "Visit Project",
                m("svg", { width: 16, height: 16, viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", "stroke-width": 2 },
                  m("path", { d: "M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6M15 3h6v6M10 14L21 3" }))
              ]) : null,

              // Interactive Components
              isTemperatureGlobe ? m("div.mt-8", m(TemperatureGlobe)) : null,

              // Standard Gallery (only if NOT interactive)
              !isInteractive && ((project.videos && project.videos.length) || (project.galleryImages && project.galleryImages.length))
                ? m("div.modal-gallery-section", [
                  m("h3.modal-section-heading", "Project Gallery"),
                  project.videos && project.videos.length
                    ? project.videos.map(function (url, i) {
                      return m("div.modal-video", { key: "v" + i }, [
                        m("iframe", {
                          src: getYouTubeEmbedUrl(url),
                          title: project.title + " \u2014 Video " + (i + 1),
                          frameborder: "0",
                          allow: "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture",
                          allowfullscreen: true,
                        }),
                      ])
                    })
                    : null,
                  project.galleryImages && project.galleryImages.length
                    ? m("div.modal-gallery",
                      project.galleryImages.map(function (src, i) {
                        var imgIndex = allImages.indexOf(src)
                        return m("div.modal-gallery-item", {
                          key: "g" + i,
                          onclick: function () { openLightbox(allImages, imgIndex !== -1 ? imgIndex : 0) },
                        }, [
                          m("img", { src: src, alt: project.title + " \u2014 " + (i + 1), loading: "lazy" }),
                        ])
                      }))
                    : null,
                ])
                : null,
            ]),
            
            // Sidebar (Hide for interactive to give more space)
            !isInteractive ? m("aside.modal-sidebar", [
              project.client
                ? m("div.modal-meta-block", [
                  m("h4", "Client"),
                  m("p", project.client),
                ])
                : null,
              project.role
                ? m("div.modal-meta-block", [
                  m("h4", "Role"),
                  m("p", project.role),
                ])
                : null,
              m("div.modal-meta-block", [
                m("h4", "Year"),
                m("p", project.year),
              ]),
              project.tools && project.tools.length
                ? m("div.modal-meta-block", [
                  m("h4", "Tools"),
                  m("div.modal-tools",
                    project.tools.map(function (t) {
                      return m("span.modal-tool-tag", { key: t }, t)
                    })),
                ])
                : null,
            ]) : null,
          ]),
        ] : null),
      ]),
      m(LightboxOverlay),
    ])
  },
}
